(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('Astreinte', Astreinte);

    Astreinte.$inject = ['$resource', 'DateUtils'];

    function Astreinte ($resource, DateUtils) {
        var resourceUrl =  'api/astreintes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'autoDetect': {
            	url:'api/astreintes/autoDetect',
            	method: 'PUT',
            	hasBody:false
            },
            'createFromAstreintePlanifie': {
                url:'api/astreintes/createFromAstreintePlanifie',
                method: 'POST',
                hasBody: true,
                isArray: false,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.astreintePlanifie.date = DateUtils.convertLocalDateToServer(copy.astreintePlanifie.date);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
